import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Global } from "../classes/Global";
import { InternationalizationHelper } from "../helpers/InternationalizationHelper";
import { PriceHelper } from "../helpers/PriceHelper";
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-grid-item-prices',
  templateUrl: './grid-item-prices.component.html',
  styleUrls: ['./grid-item-prices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridItemPricesComponent extends BaseComponent implements OnInit {

  @Input() item;
  @Input() currency: string; //in case we want to force a currency, OR the item does not contain one
  @Input() priceHint: string;

  currentPriceKey: string;
  rentalPriceKey: string;
  oldPriceKey: string;
  priceIsBestKey: string;
  priceDropIndicatorKey: string;

  constructor() {
    super();
  }

  ngOnInit() {
    //Assign these keys only at init because otherwise, when we change between buymovies and rentalmovies, 
    //we see the prices change before the request is loaded    
    this.currentPriceKey = PriceHelper.getCompletePriceKey("", this.priceHint, this.item, false);
    this.rentalPriceKey = PriceHelper.getCompletePriceKey("", this.priceHint, this.item, true);
    this.oldPriceKey = PriceHelper.getCompletePriceKey("Before", this.priceHint, this.item, false);
    this.priceIsBestKey = PriceHelper.getCompletePriceKey("IsBest", this.priceHint, this.item, false);
    this.priceDropIndicatorKey = PriceHelper.getCompletePriceKey("DropIndicator", this.priceHint, this.item, false);
  }

  getCurrentPrice() {
    const currentPrice = this.item[this.currentPriceKey];
    const rentalPrice = this.getRentalPrice();

    if(currentPrice == null && rentalPrice == null) {
      return this.getString("notAvailable");
    }
    else if(currentPrice == null && rentalPrice != null) {
      return this.getString("rentOnly");
    }
    else if(currentPrice == 0){
      return this.getString("free");
    }
    return this.formatPrice(currentPrice, this.currency || this.item.currency);
  }

  getRentalPrice() {
    if (this.item[this.rentalPriceKey] != null) {
      return this.item[this.rentalPriceKey];
    }

    const rentalKeys = ["rentalPrice4k", "rentalPriceHd", "rentalPriceHD", "rentalPriceSd", "rentalPriceSD", "rentalPrice"];
    for (let i = 0; i < rentalKeys.length; i++) {
      if (this.item[rentalKeys[i]] != null) {
        return this.item[rentalKeys[i]];
      }
    }
    return null;
  }

  getOldPrice() {
    if(this.item[this.oldPriceKey] == 0){
      return this.getString("free");
    }
    return this.formatPrice(this.item[this.oldPriceKey], this.currency || this.item.currency);
  }

  getPriceIsBest() {
    return this.item[this.priceIsBestKey];
  }

  getPriceDropIndicator() {
    return this.item[this.priceDropIndicatorKey];
  }

  formatPrice(price, currency:string): string {
    return PriceHelper.formatPrice(price, currency);
  }

}
